module.exports = __webpack_public_path__ + "assets/ozon_100.0ca1229bc5daaddcbe66efb30f63e09face20e0d4d799cf6ada6015ee7119c07.png";